import { ButtonProps } from '@chakra-ui/react'
import moment from 'moment'

import {
  ColumnState,
  TableColumnConfig,
} from '../../widgets/TableWidget/tablewidget.parts'

export interface ExportModalProps extends ButtonProps {
  queryId?: string
  title?: string
  exportTitle?: string
  isOpen?: boolean
  onOpen?: () => void
  onClose?: () => void
  columns?: ColumnState[]
  columnConfigs?: TableColumnConfig[]
  connectionLocator?: any // TODO: Define proper type for connection locator
  queryVariables?: Record<string, any>
  queryDefinitionId?: string
  renderTrigger?: React.ReactNode
}

export const createDefaultName = (title: string) => {
  const titleDate = moment().format('YYYY-MM-DD')
  return `${titleDate} ${title}`
}
